(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["midnight-home"] && !Shopify.designMode) return;
  try {
    
const initPlayStationShowcase = root => {
  const sections = root.matches?.('[data-mn-ps]') ? [root] : [...(root.querySelectorAll?.('[data-mn-ps]') || [])];
  sections.forEach(section => {
    if (section.dataset.mnPsReady) return;
    section.dataset.mnPsReady = 'true';
    const track = section.querySelector('[data-mn-ps-track]');
    const cards = [...section.querySelectorAll('.mn-ps-card')];
    const progress = section.querySelector('[data-mn-ps-progress]');
    const dialog = section.querySelector('[data-mn-ps-dialog]');
    const dialogVideo = dialog?.querySelector('video');
    const dialogTitle = dialog?.querySelector('[data-mn-ps-dialog-title]');
    const autoplayToggle = section.querySelector('[data-mn-ps-autoplay-toggle]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0;
    let inView = false;
    let userPaused = true;
    let previewTimer;
    let scrollTimer;
    const updateProgress = () => {
      if (!track || !progress) return;
      const distance = track.scrollWidth - track.clientWidth;
      const ratio = distance > 0 ? track.scrollLeft / distance : 0;
      progress.style.transform = `translateX(${ratio * 400}%)`;
    };
    const stopPreviews = () => {
      window.clearTimeout(previewTimer);
      cards.forEach(card => {
        card.classList.remove('is-previewing');
        const preview = card.querySelector('.mn-ps-preview-video');
        if (preview) {
          preview.pause();
          preview.removeAttribute('src');
          preview.load();
        }
      });
    };
    const nearestCard = () => {
      if (!track) return active;
      const center = track.scrollLeft + track.clientWidth / 2;
      return cards.reduce((nearest, card, index) => Math.abs(card.offsetLeft + card.offsetWidth / 2 - center) < Math.abs(cards[nearest].offsetLeft + cards[nearest].offsetWidth / 2 - center) ? index : nearest, 0);
    };
    const goTo = index => {
      if (!track || !cards.length) return;
      active = (index + cards.length) % cards.length;
      const card = cards[active];
      track.scrollTo({ left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior: 'instant' });
    };
    const startPreview = index => { active = (index + cards.length) % cards.length; };
    const settle = () => {
      active = nearestCard();
      startPreview(active);
    };
    section.querySelector('[data-mn-ps-prev]')?.addEventListener('click', () => goTo(active - 1));
    section.querySelector('[data-mn-ps-next]')?.addEventListener('click', () => goTo(active + 1));
    track?.addEventListener('scroll', () => {
      updateProgress();
      stopPreviews();
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(settle, 260);
    }, { passive: true });
    autoplayToggle?.addEventListener('click', () => {
      userPaused = !userPaused;
      section.classList.toggle('is-preview-paused', userPaused);
      autoplayToggle.setAttribute('aria-pressed', String(userPaused));
      autoplayToggle.textContent = userPaused ? '▶ Önizlemeyi başlat' : 'Ⅱ Önizlemeler';
      if (userPaused) stopPreviews(); else startPreview(active);
    });
    section.querySelectorAll('[data-mn-ps-play]').forEach(button => button.addEventListener('click', () => {
      if (!dialog || !dialogVideo) return;
      stopPreviews();
      const title = button.dataset.videoTitle || '';
      const media = button.closest('[data-mn-ps-preview]');
      dialogVideo.setAttribute('aria-label', `${title} trailer`);
      const soundOn = button.closest('.mn-ps-card')?.dataset.game === 'mw4';
      dialogVideo.muted = !soundOn;
      dialogVideo.controls = soundOn;
      dialogVideo.loop = !soundOn;
      dialogVideo.src = media?.dataset.videoUrl || '';
      if (dialogTitle) dialogTitle.textContent = title;
      dialog.showModal();
      dialogVideo.play().catch(() => { dialogVideo.controls = true; });
    }));
    const close = () => { if (dialog?.open) dialog.close(); };
    section.querySelector('[data-mn-ps-close]')?.addEventListener('click', close);
    dialog?.addEventListener('click', event => { if (event.target === dialog) close(); });
    dialog?.addEventListener('close', () => {
      if (dialogVideo) {
        dialogVideo.pause();
        dialogVideo.removeAttribute('src');
        dialogVideo.load();
      }
      startPreview(active);
    });
    document.addEventListener('visibilitychange', () => { if (document.hidden) stopPreviews(); else startPreview(active); });
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) { userPaused = true; stopPreviews(); }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        inView = Boolean(entries[0]?.isIntersecting);
        if (inView) startPreview(nearestCard()); else stopPreviews();
      }, { threshold: .35 }).observe(section);
    } else {
      inView = true;
      startPreview(0);
    }
    if (userPaused && autoplayToggle) {
      section.classList.add('is-preview-paused');
      autoplayToggle.setAttribute('aria-pressed', 'true');
      autoplayToggle.textContent = '▶ Önizlemeyi başlat';
    }
    updateProgress();
  });
};
initPlayStationShowcase(document);
document.addEventListener('shopify:section:load', event => initPlayStationShowcase(event.target));



  } catch(e) { console.error(e); }
})();
})();
